import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "employee",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "employees.name",
  },
  {
    name: "date",
    type: "date",
    sortable: true,
    searchable: true,
  },
  {
    name: "reason",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "amount",
    type: "money",
    sortable: true,
    searchable: true,
  },
];

export default function List({ title, query }) {
  return (
    <ResourceListPage
      url="penalties"
      columns={columns}
      title={title}
      baseQuery={query}
    />
  );
}
